import { createFileRoute } from "@tanstack/react-router";
import BatchDetail from "../components/BatchDetail";

export const Route = createFileRoute("/batch/$batchId")({
  component: BatchDetail,
});
